export const SET_LOCATIONS_DATA = '[LOCATIONS] SET_LOCATIONS_DATA';

export const setLocationsData = (data) => ({
  type: SET_LOCATIONS_DATA,
  payload: data,
});
